import React, { useState, useEffect, useRef } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import L from "leaflet";
import axios from "axios";

import searchh from "/searchh.png?url";
import Mask from "/Mask.png?url";
import centerIcon from "/center.png?url";
import Frame from "/Frame.png?url";

const MapComponent = ({ onLocationSelect, onClose }) => {
  const mapRef = useRef(null);
  const markerRef = useRef(null);
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [location, setLocation] = useState("");
  const [search, setSearch] = useState("");
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [showMap, setShowMap] = useState(true);
  const [clearable, setClearable] = useState(false);

  const MapEvents = () => {
    const map = useMapEvents({
      click: async (e) => {
        const { lat, lng } = e.latlng;
        setLat(lat);
        setLng(lng);
        map.setView([lat, lng], map.getZoom());

        try {
          const response = await axios.get(
            `https://nominatim.openstreetmap.org/reverse`,
            {
              params: {
                lat: lat,
                lon: lng,
                format: "json",
              },
            }
          );
          const address = response.data.display_name;
          setLocation(address);
          updateMap(lat, lng, address);
        } catch (error) {
          console.error("Error fetching address:", error);
        }
      },
    });

    return null;
  };

  const handlePopupClick = () => {
    const selectedData = {
      location,
      lat,
      lng,
    };
    console.log(`Location: ${location}, Lat: ${lat}, Lng: ${lng}`);
    onLocationSelect(selectedData);
    onClose();
  };

  useEffect(() => {
    if (markerRef.current) {
      markerRef.current.openPopup();
    }
  }, [lat, lng]);

  const handleCloseMap = () => {
    setShowMap(false);
    setLat(null);
    setLng(null);
    setLocation("");
    setSearch("");
    setClearable(false);
    if (markerRef.current) {
      markerRef.current.remove();
      markerRef.current = null;
    }
    onClose();
  };

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearch(query);
    setClearable(query.length > 0);
    if (!query.trim()) {
      setSearchResults([]);
      setDropdownVisible(false);
    } else {
      performSearch(query);
      setDropdownVisible(true);
    }
  };

  const handleSearchKeyPress = async (event) => {
    if (event.key === "Enter" && search.trim()) {
      performSearch(search);
    }
  };

  const performSearch = async (query) => {
    if (!query.trim()) {
      setSearchResults([]);
      setDropdownVisible(false);
      return;
    }

    try {
      const response = await axios.get(
        `https://nominatim.openstreetmap.org/search`,
        {
          params: {
            q: query,
            format: "json",
            addressdetails: 1,
            limit: 5,
          },
        }
      );
      setSearchResults(response.data);
      setDropdownVisible(true);
    } catch (error) {
      console.error("Error during location search:", error);
      setSearchResults([]);
      setDropdownVisible(false);
    }
  };

  const handleLocationSelect = (item) => {
    const { lat, lon, display_name } = item;
    setLat(parseFloat(lat));
    setLng(parseFloat(lon));
    setLocation(display_name);
    setSearch(display_name);
    setClearable(true);
    updateMap(parseFloat(lat), parseFloat(lon), display_name);
    setSearchResults([]);
    setDropdownVisible(false);
  };

  const updateMap = (latitude, longitude, displayName) => {
    const newLatLng = new L.LatLng(latitude, longitude);
    if (mapRef.current) {
      mapRef.current.setView(newLatLng, mapRef.current.getZoom(), { animate: true });
      if (markerRef.current) {
        markerRef.current.setLatLng(newLatLng);
      } else {
        const newMarker = L.marker(newLatLng).addTo(mapRef.current);
        markerRef.current = newMarker;
      }
      markerRef.current
        .bindPopup(
          `<div class="popUp" style="cursor: pointer;" onclick="window.popupClick(${latitude}, ${longitude}, '${displayName}')">
            <strong style="color: #000000;">${displayName}</strong><br />
            <span style="color: #000000;">Lat: ${latitude.toFixed(6)}, Lng: ${longitude.toFixed(6)}</span><br />
            <span style="color: #000000;">คลิกเพื่อเลือกตำแหน่งนี้</span>
          </div>`
        )
        .openPopup();
    }
  };

  const handleClearInput = () => {
    setSearch("");
    setClearable(false);
    setSearchResults([]);
    setDropdownVisible(false);
  };

  const SearchResultDropdown = () => {
    if (searchResults.length === 0) {
      return null;
    }
    return (
      <ul className="search-results-dropdown">
        {searchResults.slice(0, 5).map((item, index) => (
          <li key={index} onClick={() => handleLocationSelect(item)}>
            <img src={Mask} alt="Mask" className="Mask" />
            <img src={Frame} alt="Frame" className="Frame" />
            {item.display_name}
          </li>
        ))}
      </ul>
    );
  };

  const handleCenterToCurrentLocation = async () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          setLat(latitude);
          setLng(longitude);
          
          try {
            const response = await axios.get(
              `https://nominatim.openstreetmap.org/reverse`,
              {
                params: {
                  lat: latitude,
                  lon: longitude,
                  format: "json",
                },
              }
            );
            const address = response.data.display_name;
            setLocation(address);
            updateMap(latitude, longitude, address);
          } catch (error) {
            console.error("Error fetching address:", error);
            const defaultText = "ตำแหน่งที่ตั้ง ณ ปัจจุบัน";
            setLocation(defaultText);
            updateMap(latitude, longitude, defaultText);
          }
        },
        (error) => {
          console.error("Error obtaining location", error);
        },
        { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  return (
    <>
      <div className="BranchModal">
        <div className="map-container">
          <button className="close-map-button" onClick={handleCloseMap}>
            &times;
          </button>
          <div className="searchMap">
            {clearable && (
              <div className="clear-map-button" onClick={handleClearInput}>
                &times;
              </div>
            )}
            <input
              type="text"
              placeholder="ค้นหาสถานที่ตั้ง"
              className="search-bar"
              value={search}
              onChange={handleSearchChange}
              onKeyPress={handleSearchKeyPress}
            />
            <img src={searchh} alt="search" className="searchh" />
            {dropdownVisible && <SearchResultDropdown />}
          </div>
          <button className="center" onClick={handleCenterToCurrentLocation}>
            <img src={centerIcon} alt="Center" />
            <span className="tooltiptext">ตำแหน่งของคุณ</span>
          </button>
          <MapContainer
            center={[lat || 13.736717, lng || 100.523186]}
            zoom={13}
            style={{
              height: "100%",
              width: "100%",
              borderRadius: "10px",
            }}
            whenCreated={(mapInstance) => {
              mapRef.current = mapInstance;
            }}
          >
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <MapEvents />
            {lat && lng && (
              <Marker position={[lat, lng]} ref={markerRef}>
                <Popup closeButton={false}>
                  <div
                    className="popUp"
                    style={{ cursor: "pointer" }}
                    onClick={handlePopupClick}
                  >
                    <strong style={{ color: "#000000" }}>{location}</strong>
                    <br />
                    <span style={{ color: "#000000" }}>
                      Lat: {lat}, Lng: {lng}
                    </span>
                    <br />
                    <span style={{ color: "#000000" }}>
                      คลิกเพื่อเลือกตำแหน่งนี้
                    </span>
                  </div>
                </Popup>
              </Marker>
            )}
          </MapContainer>
        </div>
      </div>
    </>
  );
};

export default MapComponent;